export default __webpack_public_path__ + "static/media/area_of_opertation_detail.3d03664f.svg";